/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const ConfirmEmailVerificationBody = zod.object({});

export type ConfirmEmailVerificationBody = zod.input<typeof ConfirmEmailVerificationBody>;
export type ConfirmEmailVerificationBodyOutput = zod.output<typeof ConfirmEmailVerificationBody>;
